import { DeepKeys } from '@tanstack/table-core';

import { Insurance } from '@data-access';

// eslint-disable-next-line @typescript-eslint/ban-types
type accessorKey = DeepKeys<Insurance> | (string & {});
type ColVisibilityState = Partial<Record<accessorKey, boolean>>;

const defaultColStates: ColVisibilityState = {
  'field.thumbnail': true,
  'field.name': true,
  'field.farm.name': true,

  seed_date: false,
  is_harvested: false,
  'department.name': false,
  max_LAI: false,

  rain_seeding: false,
  rain_cycle: false,
  rain_harvest: false,
  status: false,
};

export const dataColStates: ColVisibilityState = {
  ...defaultColStates,

  seed_date: true,
  is_harvested: true,
  'department.name': true,
  max_LAI: true,
};

export const resultsColStates: ColVisibilityState = {
  ...defaultColStates,

  is_harvested: true,
  max_LAI: true,
  rain_seeding: true,
  rain_cycle: true,
  rain_harvest: true,
  status: true,
};
